import { axiosV2 } from "config/@axios";

export const IN_FETCHING = "rulesActions::inFetching";
export const OUT_FETCHING = "rulesActions::outFetching";
export const SET_IN_ERROR_MESSAGE = "rulesActions::setInErrorMessage";
export const SET_OUT_ERROR_MESSAGE = "rulesActions::setOutErrorMessage";
export const FETCH_IN_SUCCESS = "rulesActions::fetchInSuccess";
export const FETCH_OUT_SUCCESS = "rulesActions::fetchOutSuccess";
export const CHANGE_STATUS = "rulesActions::changeStatus";
export const ADD = "rulesActions::add";
export const UPDATE = "rulesActions::update";
export const MOVE = "rulesActions::move";
export const REMOVE = "rulesActions::remove";
export const RESET = "rulesActions::reset";

export const fetch =
  (direction = "in", next = () => {}) =>
  dispatch => {
    dispatch({ type: direction === "in" ? IN_FETCHING : OUT_FETCHING });
    return axiosV2
      .get("rules", {
        params: {
          direction: direction
        }
      })
      .then(response => {
        dispatch({
          type: direction === "in" ? FETCH_IN_SUCCESS : FETCH_OUT_SUCCESS,
          payload: response.data
        });
        next();
      })
      .catch(error => {
        dispatch({
          type:
            direction === "in" ? SET_IN_ERROR_MESSAGE : SET_OUT_ERROR_MESSAGE,
          payload: error.message
        });
      });
  };

export const move =
  (direction = "in", dragIndex, hoverIndex) =>
  async (dispatch, getState) => {
    await dispatch({
      type: MOVE,
      payload: { direction, dragIndex, hoverIndex }
    });
    const state = getState();
    dispatch(
      update(direction, state.rules[`${direction}Rules`], () => {}, true)
    );
  };

export const add =
  (direction = "in", data, next = () => {}) =>
  (dispatch, getState) => {
    return dispatch(
      fetch(direction, async () => {
        await dispatch({ type: ADD, payload: { direction, data } });
        const state = getState();
        return await dispatch(
          update(direction, state.rules[`${direction}Rules`], next)
        );
      })
    );
  };

export const remove =
  (direction = "in", index) =>
  async (dispatch, getState) => {
    await dispatch({ type: REMOVE, payload: { direction, index } });
    const state = getState();
    return dispatch(update(direction, state.rules[`${direction}Rules`]));
  };

export const changeStatus =
  (direction = "in", index, status) =>
  async (dispatch, getState) => {
    await dispatch({
      type: CHANGE_STATUS,
      payload: { direction, index, status }
    });
    const state = getState();
    return dispatch(update(direction, state.rules[`${direction}Rules`]));
  };

export const updateRow =
  (direction = "in", index, data, next = () => {}, silence = false) =>
  async (dispatch, getState) => {
    await dispatch({
      type: UPDATE,
      payload: { direction, index, data }
    });
    const state = getState();
    return dispatch(
      update(direction, state.rules[`${direction}Rules`], next, silence)
    );
  };

export const update =
  (direction = "in", data, next = () => {}, silence = false) =>
  dispatch => {
    !silence &&
      dispatch({ type: direction === "in" ? IN_FETCHING : OUT_FETCHING });
    return axiosV2
      .put("rules", data)
      .then(response => {
        !silence &&
          dispatch({
            type: direction === "in" ? FETCH_IN_SUCCESS : FETCH_OUT_SUCCESS,
            payload: response.data
          });
        next();
      })
      .catch(error => {
        dispatch({
          type:
            direction === "in" ? SET_IN_ERROR_MESSAGE : SET_OUT_ERROR_MESSAGE,
          payload: error.message
        });
      });
  };
